import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, COLOR_MAIN_LABEL } from '../../../globals';


export const StyledLabelMainColor = styled.h2`
  padding: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  font-weight: bold;
  font-size: 1em;
  color: ${COLOR_MAIN_LABEL};
`;
